import { createGtm } from "@gtm-support/vue-gtm";
import * as Sentry from "@sentry/vue";

const ignoredThirdPartyErrorUrls = [
  /li\.lms-analytics\/insight\.old\.min\.js/i,
];

function isIgnoredThirdPartyError(event) {
  const frames = event.exception?.values?.flatMap(
    (exception) => exception.stacktrace?.frames || [],
  );

  return frames?.some((frame) =>
    ignoredThirdPartyErrorUrls.some((url) => url.test(frame.filename || "")),
  );
}

export function initializeGtm(app, router) {
  const gdpr = localStorage.getItem("vue-cookie-accept-decline-gdpr");

  app.use(
    createGtm({
      id: import.meta.env.VITE_GTM_ID,
      defer: false,
      enabled: gdpr == "accept",
      debug: import.meta.env.MODE == "development",
      loadScript: true,
      vueRouter: router,
      trackOnNextTick: false,
    }),
  );
  console.log("gtm initialized .....");
}

export function initializeSentry(app, router) {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
      integrations: [
        new Sentry.BrowserTracing({
          tracePropagationTargets: [
            import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS,
          ],
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
      ],
      tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE,
      replaysOnErrorSampleRate: 1.0,
      denyUrls: ignoredThirdPartyErrorUrls,
      beforeSend(event) {
        if (isIgnoredThirdPartyError(event)) {
          return null;
        }

        return event;
      },
    });
  }
}
